'use client';

import { useContext } from 'react';
import { ToastContext, type ToastType } from '@/contexts/ToastContext';
import { X, CheckCircle, AlertCircle, AlertTriangle, Info } from 'lucide-react';

const icons: Record<ToastType, typeof CheckCircle> = {
  success: CheckCircle,
  error: AlertCircle,
  warning: AlertTriangle,
  info: Info,
};

const alertClass: Record<ToastType, string> = {
  success: 'alert-success',
  error: 'alert-error',
  warning: 'alert-warning',
  info: 'alert-info',
};

export function ToastContainer() {
  const ctx = useContext(ToastContext);
  if (!ctx || ctx.toasts.length === 0) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2 max-w-sm">
      {ctx.toasts.map((toast) => {
        const Icon = icons[toast.type];
        return (
          <div
            key={toast.id}
            className={`alert ${alertClass[toast.type]} shadow-lg animate-fade-in text-sm py-3`}
          >
            <Icon size={16} />
            <span className="flex-1">{toast.message}</span>
            <button
              onClick={() => ctx.removeToast(toast.id)}
              className="btn btn-ghost btn-xs btn-circle"
            >
              <X size={12} />
            </button>
          </div>
        );
      })}
    </div>
  );
}
